// Storage service 
const getItem = (key) => {
  return localStorage.getItem(`tra_${key}`);
};

/**
 * Set an item in localStorage, with prefix for this app
 */
const setItem = (key, value) => {
  localStorage.setItem(`tra_${key}`, value);
};

/**
 * Remove an item from localStorage
 */
const removeItem = (key) => {
  localStorage.removeItem(`tra_${key}`);
};

export default {
  getItem,
  setItem,
  removeItem
};
